export const getAssignee = message => message?.conversation?.assignee_id;
export const isConversationUnassigned = message => !getAssignee(message);
export const isConversationAssignedToMe = (message, currentUserId) =>
  getAssignee(message) === currentUserId;
export const isMessageFromCurrentUser = (message, currentUserId) =>
  message?.sender?.id === currentUserId;

export const buildMessageFromConversation = conversation => {
  const { messages = [] } = conversation;
  const lastMessage = messages[messages.length - 1];
  if (!lastMessage) return null;

  return {
    ...lastMessage,
    conversation_id: conversation.id,
    conversation: {
      assignee_id: conversation.meta?.assignee?.id ?? null,
      status: conversation.status,
      unread_count: conversation.unread_count,
      last_activity_at: conversation.last_activity_at,
    },
  };
};
